<template>
  <div v-if="shortBtn" @click="handleClick">
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" viewBox="0 0 1000 332" class="_cursor-container img-fluid">
      <g id="Button_1" data-name="Button - 1" clip-path="url(#clip-Button_1)">
        <g id="Group_8348" data-name="Group 8348" transform="translate(-989 -1638)">
          <g id="Component_6_21" data-name="Component 6 - 21" transform="translate(995 1648.036)">
            <rect id="Rectangle_18109" data-name="Rectangle 18109" width="990.525" height="222.83" rx="81" fill="#ffbc0d"/>
            <g id="Group_45" data-name="Group 45" transform="translate(449.471 218.922)">
              <path id="Path_16" data-name="Path 16" d="M0,0H14.449c44.416,1.947,66.93,51.588,113.9,43.786,16.944-2.81,31.058-13.468,48.762-13.623C219.478,29.8,240.276,82.3,279.8,91.4a49.425,49.425,0,0,0,35.261-3.619,74.184,74.184,0,0,0,23.552-23.051C349.8,49.01,359.763,31.96,373.144,18.2,380.418,10.713,389.2,3.764,399.17,1.482A70.12,70.12,0,0,1,410.879,0h16.277" transform="translate(0 0.001)" fill="#ffbc0d"/>
            </g>
          </g>
          <circle v-show="btnIcon" id="Ellipse_752" data-name="Ellipse 752" cx="84.5" cy="84.5" r="84.5" transform="translate(1784 1671)" fill="#db0e13" />
          <path v-show="btnIcon" id="Path_7041" data-name="Path 7041" d="M53.83-1.925a4.708,4.708,0,0,0,0-6.658L15.706-46.708a4.708,4.708,0,0,0-6.658,0L4.6-42.261a4.708,4.708,0,0,0-.008,6.65L34.808-5.254,4.593,25.1a4.708,4.708,0,0,0,.008,6.65L9.048,36.2a4.708,4.708,0,0,0,6.658,0Z" transform="translate(1841.693 1761.214)" fill="#ffbc0d"/>
        </g>
      </g>
      <text :x="btnIcon ? '40%' : '50%'" y="40%" text-anchor="middle" class="speedee-bold test" style="font-size: 5em;">
        {{ text }}
      </text>
    </svg>
  </div>
  <div v-else @click="handleClick">
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" viewBox="0 0 2000 332" class="cursor-container img-fluid">
      <g id="Button_1" data-name="Button - 1" clip-path="url(#clip-Button_1)">
        <g id="Group_8348" data-name="Group 8348" transform="translate(-989 -1638)">
          <g id="Component_6_21" data-name="Component 6 - 21" transform="translate(995 1648.036)">
            <rect id="Rectangle_18109" data-name="Rectangle 18109" width="2000" height="222.83" rx="81"
              fill="#ffbc0d" />
            <g id="Group_45" data-name="Group 45" transform="translate(1449.471 218.922)">
              <path id="Path_16" data-name="Path 16"
                d="M0,0H14.449c44.416,1.947,66.93,51.588,113.9,43.786,16.944-2.81,31.058-13.468,48.762-13.623C219.478,29.8,240.276,82.3,279.8,91.4a49.425,49.425,0,0,0,35.261-3.619,74.184,74.184,0,0,0,23.552-23.051C349.8,49.01,359.763,31.96,373.144,18.2,380.418,10.713,389.2,3.764,399.17,1.482A70.12,70.12,0,0,1,410.879,0h16.277"
                transform="translate(0 0.001)" fill="#ffbc0d" />
            </g>
          </g>
          
          <circle v-show="btnIcon" id="Ellipse_752" data-name="Ellipse 752" cx="1083.5" cy="84.5" r="84.5"
            transform="translate(1784 1671)" fill="#db0e13" />
          <path v-show="btnIcon" id="Path_7041" data-name="Path 7041"
            d="M53.83-1.925a4.708,4.708,0,0,0,0-6.658L15.706-46.708a4.708,4.708,0,0,0-6.658,0L4.6-42.261a4.708,4.708,0,0,0-.008,6.65L34.808-5.254,4.593,25.1a4.708,4.708,0,0,0,.008,6.65L9.048,36.2a4.708,4.708,0,0,0,6.658,0Z"
            transform="translate(1841.693 1761.214)" fill="#ffbc0d" />
        </g>
      </g>
      <text :x="btnIcon ? '40%' : '50%'" y="40%" text-anchor="middle" fill="black" class="speedee-bold"
        style="font-size: 5em;">
        {{ text }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    text: {
      Type: String,
      default: 'No Text'
    },

    btnIcon: {
      Type: Boolean,
      default: true,
    },

    width: {
      Type: String,
      default: '200'
    },

    shortBtn: {
      Type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    handleClick() {
      this.$emit('click')
    }
  },
}
</script>

<style>
._cursor-container {
  fill: black;
  transition: fill 0.3s ease;
  cursor: default;
}

._cursor-container:hover {
  cursor: pointer;
  fill: blue;
}
</style>